import { style, styleVariants } from "@vanilla-extract/css";

import { text } from "~/styles/type.css";
import { vars } from "~/styles/tokens.css";

// Card container — surface background, subtle border, rounded corners,
// with a light drop shadow for elevation. Matches Teresa's design cue
// of "card-based layout with colored left-border accents" from
// docs/teresa-prototype-findings.md; the shadow is our addition so
// cards read as lifted from the page surface without a heavy border.
const base = style({
  backgroundColor: vars.color.surface,
  borderRadius: vars.radius.lg,
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: vars.color.borderSubtle,
  boxShadow: vars.shadow.sm,
});

// Density axis, independent of accent. `standard` is a page-level card;
// `dense` is for cards that appear in quantity on one screen (board
// columns, rail items) where standard padding costs more rows than the
// breathing room is worth.
export const density = styleVariants({
  standard: { padding: vars.space.lg },
  dense: { padding: vars.space.md },
});

export const heading = style([
  text.micro,
  {
    color: vars.color.textMuted,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
  },
]);

export const titleRow = style({
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",
  gap: vars.space.md,
});

export const title = style([
  text.heading,
  {
    margin: 0,
    color: vars.color.textDefault,
  },
]);

// Accent variants — "neutral" (no accent), plus the colored left-border
// states. Each accent uses borderLeft to widen the left edge and paint
// it with a semantic status color.
export const card = styleVariants({
  neutral: [base],
  primary: [
    base,
    {
      borderLeftWidth: "4px",
      borderLeftColor: vars.color.primary,
    },
  ],
  success: [
    base,
    {
      borderLeftWidth: "4px",
      borderLeftColor: vars.color.success,
    },
  ],
  warning: [
    base,
    {
      borderLeftWidth: "4px",
      borderLeftColor: vars.color.warning,
    },
  ],
  danger: [
    base,
    {
      borderLeftWidth: "4px",
      borderLeftColor: vars.color.danger,
    },
  ],
  info: [
    base,
    {
      borderLeftWidth: "4px",
      borderLeftColor: vars.color.info,
    },
  ],
});
